import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-auth-user',
  templateUrl: './auth-user.component.html',
  styleUrls: ['./auth-user.component.sass']
})
export class AuthUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
